import { Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import React, { ButtonHTMLAttributes, useMemo } from 'react';

import { useStyles } from './styles';

interface ResultsCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  value: number;
  selected?: boolean;
}

const ResultsCard: React.FC<ResultsCardProps> = ({
  title,
  value,
  selected,
  ...rest
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const color = useMemo(() => {
    if (value < 0) {
      return theme.charts.urgent;
    }
    if (value > 0) {
      return theme.charts.low;
    }
    return '#333333';
  }, [value, theme]);

  return (
    <button
      type="button"
      className={clsx(classes.container, {
        [classes.active]: selected,
      })}
      {...rest}
    >
      <Typography variant="body1" className={classes.title}>
        {title}
      </Typography>
      <Typography variant="body1" className={classes.value} style={{ color }}>
        {value.toFixed(1)}
      </Typography>
    </button>
  );
};

export default ResultsCard;
